declare var dataLayer: any[];

/**
 * Klick auf Express-Kauf-Button im inaktiven Zustand
 */
export function inactiveButtonClickTracking() {
    dataLayer.push({
        event: 'event',
        eventCategory: 'user data',
        eventAction: 'express-kauf',
        eventLabel: 'button-click_inactive',
    });

    dataLayer.push({
        event: 'econdaEvent',
        ecCustomProperties: {
            Target: ['user data', 'express-kauf' + '/' + 'button-click_inactive', 0, 'd'],
            rqtype: 'hiddenpi',
        },
    });
}

/**
 * Klick auf Express-Kauf-Button im aktiven Zustand
 */
export function activeButtonClickTracking() {
    dataLayer.push({
        event: 'event',
        eventCategory: 'user data',
        eventAction: 'express-kauf',
        eventLabel: 'button-click_active',
    });

    dataLayer.push({
        event: 'econdaEvent',
        ecCustomProperties: {
            Target: ['user data', 'express-kauf' + '/' + 'button-click_active', 0, 'd'],
            rqtype: 'hiddenpi',
        },
    });
}

/**
 * Abgeschlossene Konfiguration der Express-Kauf-Daten in Meine Daten
 */
export function saveConfigTracking() {
    dataLayer.push({
        event: 'event',
        eventCategory: 'user data',
        eventAction: 'express-kauf',
        eventLabel: 'config_done',
    });

    dataLayer.push({
        event: 'econdaEvent',
        ecCustomProperties: {
            Target: ['user data', 'express-kauf' + '/' + 'config_done', 0, 'd'],
            rqtype: 'hiddenpi',
        },
    });
}
